import styled from "styled-components";
import { FiFileText } from "react-icons/fi";

export const DocumentsTableWrapper = styled.div`
  width: 100%;
  margin-top: ${(props) => props.theme.spacing.medium};
`;

export { StatusBadge } from "../../Pages/DueDiligence/CasesList/Styles";

export const TableToolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  flex: 1;
  max-width: 24rem;
  min-width: 200px;

  .search-icon {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: #9CA3AF;
    pointer-events: none;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 100%;
    max-width: none;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 0.625rem 1rem 0.625rem 2.75rem;
  border: 1px solid #E5E7EB;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  color: #111827;
  background-color: #FFFFFF;
  transition: all 0.2s;

  &::placeholder {
    color: #9CA3AF;
  }

  &:focus {
    outline: none;
    border-color: #D1D5DB;
    box-shadow: 0 0 0 3px rgba(229, 231, 235, 0.5);
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
  flex-shrink: 0;

  .filter-label {
    font-size: 0.75rem;
    font-weight: 500;
    color: #6B7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-right: 0.25rem;
    white-space: nowrap;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    flex-wrap: wrap;
    width: 100%;

    .filter-label {
      display: none;
    }
  }
`;

export const FilterButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid #E5E7EB;
  background-color: ${(props) => (props.$active ? "#021526" : "#ffffff")};
  color: ${(props) => (props.$active ? "#ffffff" : "#4B5563")};
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background-color: ${(props) => (props.$active ? "#021526" : "#F9FAFB")};
    color: ${(props) => (props.$active ? "#ffffff" : "#021526")};
    border-color: ${(props) => (props.$active ? "#021526" : "#D1D5DB")};
  }

  svg {
    font-size: 1rem;
  }
`;

export const FileNameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
`;

export const FileIcon = styled(FiFileText)`
  color: #9CA3AF;
  flex-shrink: 0;
`;

export const FileName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DateCell = styled.span`
  cursor: help;
  color: #6B7280;
  font-size: 0.875rem;
  white-space: nowrap;
`;

export const EmptyCell = styled.span`
  font-size: 0.875rem;
  color: #9CA3AF;
`;

export const FilterDropdownContainer = styled.div`
  position: relative;
`;

export const FilterDropdown = styled.div`
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  padding: 0.5rem;
  z-index: 10;
  min-width: 12rem;
`;

export const FilterOption = styled.button`
  width: 100%;
  text-align: left;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 0.875rem;
  color: #374151;
  transition: background-color 0.2s;

  &:hover {
    background-color: #F3F4F6;
  }
`;

export const DatePickerDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  padding: 1.25rem;
  z-index: 10;
  min-width: 20rem;
`;

export const DatePickerTitle = styled.div`
  margin-bottom: 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
`;

export const DatePickerFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DateFieldLabel = styled.label`
  display: block;
  font-size: 0.75rem;
  font-weight: 500;
  color: #6B7280;
  margin-bottom: 0.375rem;
`;

export const DateInput = styled.input`
  width: 100%;
  padding: 0.625rem;
  border: 1px solid #E5E7EB;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  color: #111827;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #021526;
    box-shadow: 0 0 0 3px rgba(2, 21, 38, 0.1);
  }

  &::placeholder {
    color: #9CA3AF;
  }
`;

export const DatePickerActions = styled.div`
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #E5E7EB;
  display: flex;
  gap: 0.5rem;
`;

export const DatePickerButton = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  flex: 1;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: ${(props) => props.$variant === 'primary' ? 'none' : '1px solid #E5E7EB'};
  background-color: ${(props) => props.$variant === 'primary' ? '#021526' : 'white'};
  color: ${(props) => props.$variant === 'primary' ? 'white' : '#374151'};

  &:hover {
    background-color: ${(props) => props.$variant === 'primary' ? '#032745' : '#F9FAFB'};
  }
`;

export const FilterBadge = styled.span`
  margin-left: 0.25rem;
  font-size: 0.75rem;
  color: inherit;
`;export const FilterCheckBadge = styled.span`
  margin-left: 0.25rem;
  font-size: 0.75rem;
  background-color: #021526;
  color: #ffffff;
  border-radius: 50%;
  width: 1.25rem;
  height: 1.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;